var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 16,
    viewBox: "0 0 22 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 19.2,
    y1: 8,
    y2: 8,
    stroke: "#E9E61C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E9E61C",
    points: "12.766 0 11.456 1.406 18.391 7.853 11.456 14.297 12.766 15.703 21.21 7.853"
  }))));
}

export default __webpack_public_path__ + "static/arrow-092eef1779aec141874627901ac29d49.svg";
export { SvgArrow as ReactComponent };